
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lCr2G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $12180461fcdd45b0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $12180461fcdd45b0$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': 'Aggiornamento dei dati di analisi in corso...',
    'confluence-analytics-chart.tooltip.no-views-data': 'Nessun dato',
    'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 visualizzazione} other {{count} visualizzazioni}}',
    'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, one {1 visualizzazione finora} other {{count} visualizzazioni finora}}',
    'confuence-analytics-chart.accessible-table.caption': 'Visualizzazioni della pagina',
    'confuence-analytics-chart.accessible-table.header.date': 'Data',
    'confuence-analytics-chart.accessible-table.header.view-count': 'Visualizzazioni',
    'confuence-analytics-chart.accessible-table.no-view-count-data': 'Nessuna visualizzazione'
};

});


//# sourceMappingURL=it.765dda08.js.map
